import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
var n = {
	defining: !0,
	content: "paragraph | heading | subheading | subheading3 | subheading4 | codeBlock",
	attrs: t({ type: { default: "collapsibleSectionSummary" } }),
	parseDOM: [{ tag: "summary" }],
	toDOM() {
		return ["summary", 0];
	}
}, r = {
	defining: !0,
	content: "(block|list|table)+",
	attrs: t({ type: { default: "collapsibleSectionContent" } }),
	parseDOM: [{ tag: `div.${e.collapsibleSectionContent}` }],
	toDOM() {
		return [
			"div",
			{ class: e.collapsibleSectionContent },
			0
		];
	}
}, i = {
	inline: !1,
	defining: !0,
	content: "collapsibleSectionSummary collapsibleSectionContent",
	group: "block",
	attrs: t({
		type: { default: "collapsibleSection" },
		open: { default: !0 }
	}),
	parseDOM: [{ tag: "details" }],
	toDOM(e) {
		return [
			"details",
			e.attrs.open ? { open: "true" } : {},
			0
		];
	}
};
//#endregion
export { r as collapsibleSectionContentSpec, i as collapsibleSectionSpec, n as collapsibleSectionSummarySpec };
